import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getTranslationsWithFallback } from './utils';
export var i18n = function i18n(translations) {
  var instance = i18next.createInstance({
    lng: 'default',
    resources: {
      default: {
        translation: getTranslationsWithFallback(translations)
      }
    },
    keySeparator: '::'
  });
  instance.use(initReactI18next).init();
  return instance;
};